// extracted by mini-css-extract-plugin
export default {"scene3DWrapper":"Scene3D_scene3DWrapper__rwyqG","tutorialWrapper":"Scene3D_tutorialWrapper__JLB7f"};